import AsyncSelect from "react-select/async";
import { SearchFieldStyles } from "./SearchFieldStyles";
import { useSelector } from "react-redux";
import servSolicitacaoVistoria from "../../services/login/servSolicitacaoVistoria";
import { maskUC } from "../../infra/utils/maskUC";

const SolicAcessoSearchField = ({ field, id, setOpenError, setErrorMessage, disabled = false, className = "" }) => {
    const user = useSelector(state => state.user);
    const uc = useSelector(state => state.uc);

    const loadSolicitacoes = async (inputValue) => {
        try {

            const response = await servSolicitacaoVistoria.listarParaVistoria(user.codigoUsuario, inputValue);

            let data = response.Content.map(mapResponseToValuesAndLabels);

            return data;

        } catch (err) {
            setOpenError(true);
            setErrorMessage(err.response.data.Message);
        }
    }

    const mapResponseToValuesAndLabels = (data) => {
        let label = data.Id;

        label += ` - ${data.Nome}`;

        switch (data.Situacao) {
            case 0:
                label += ` - Em digitação`;
            case 1:
                label += ` - Aguardando análise`;
                break;
            case 2:
                label += ` - Revisar solicitação`;
                break;
            case 4:
                label += ` - Aprovada`;
                break;
            default:
                label += ` - Arquivada`;
                break;
        }

        if (data.CodigoUC) {
            const valorFormatado = uc?.rn1095 ? maskUC(String(data.CodigoUC)) : data.CodigoUC;

            label += `- UC: ${valorFormatado}`;
        } else {
            label += ' - UC: Não informado';
        }

        return {
            value: data.Id,
            label: label
        }
    }

    return (
        <AsyncSelect
            id={id}
            cacheOptions
            placeholder="Orçamento de conexão - Interessado"
            loadOptions={loadSolicitacoes}
            defaultOptions
            isDisabled={!disabled}
            styles={SearchFieldStyles}
            className={className}
            {...field}
        />
    )
}

export { SolicAcessoSearchField }